/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetSubsystemsForAssetTypeRequestDto
 */
export interface SetSubsystemsForAssetTypeRequestDto {
    /**
     * ID of the asset type
     * @type {string}
     * @memberof SetSubsystemsForAssetTypeRequestDto
     */
    assetTypeId: string;
    /**
     * Array of subsystem IDs to associate with the asset type
     * @type {Array<string>}
     * @memberof SetSubsystemsForAssetTypeRequestDto
     */
    subsystemIds: Array<string>;
}

/**
 * Check if a given object implements the SetSubsystemsForAssetTypeRequestDto interface.
 */
export function instanceOfSetSubsystemsForAssetTypeRequestDto(value: object): value is SetSubsystemsForAssetTypeRequestDto {
    if (!('assetTypeId' in value) || value['assetTypeId'] === undefined) return false;
    if (!('subsystemIds' in value) || value['subsystemIds'] === undefined) return false;
    return true;
}

export function SetSubsystemsForAssetTypeRequestDtoFromJSON(json: any): SetSubsystemsForAssetTypeRequestDto {
    return SetSubsystemsForAssetTypeRequestDtoFromJSONTyped(json, false);
}

export function SetSubsystemsForAssetTypeRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetSubsystemsForAssetTypeRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'assetTypeId': json['assetTypeId'],
        'subsystemIds': json['subsystemIds'],
    };
}

export function SetSubsystemsForAssetTypeRequestDtoToJSON(json: any): SetSubsystemsForAssetTypeRequestDto {
    return SetSubsystemsForAssetTypeRequestDtoToJSONTyped(json, false);
}

export function SetSubsystemsForAssetTypeRequestDtoToJSONTyped(value?: SetSubsystemsForAssetTypeRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assetTypeId': value['assetTypeId'],
        'subsystemIds': value['subsystemIds'],
    };
}

